import { clsx } from 'clsx'
import { styles } from 'util/style'
import css from './Divider.module.scss'

type Props = {
  className?: string;
  secondary?: boolean
  tertiary?: boolean
  vertical?: boolean
  width?: number | string
  height?: number | string
}

export function Divider(props: Props) {
  const { secondary, tertiary, width, height } = props
  const vertical = props.vertical ?? height != null

  const className = clsx(
    props.className,
    secondary && css.secondary,
    tertiary && css.tertiary,
    vertical ? css.vertical : css.horizontal,
  )
  const style = styles({ width, height })

  return <div className={className} style={style} />
}
